(function () {
  var KEY = 'ibscentPromoDismissed';
  var VAR_NAME = '--ibscent-promo-h';
  var MOBILE_MAX = 1023;

  function dismissed() {
    try { return localStorage.getItem(KEY) === '1'; } catch (e) { return false; }
  }

  function setVar(px) {
    document.documentElement.style.setProperty(VAR_NAME, px + 'px');
  }

  function measure(bar) {
    if (window.innerWidth > MOBILE_MAX) { setVar(0); return; }
    setVar(Math.round(bar.getBoundingClientRect().height));
  }

  function openForm(formId) {
    if (window.klaviyo && typeof window.klaviyo.openForm === 'function') {
      window.klaviyo.openForm(formId);
      return;
    }
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
  }

  function remove(bar) {
    if (bar && bar.parentNode) bar.parentNode.removeChild(bar);
    setVar(0);
  }

  function init() {
    var bar = document.querySelector('[data-ibscent-promo-bar]');
    if (!bar) return;

    if (dismissed()) { remove(bar); return; }

    measure(bar);

    if (typeof ResizeObserver === 'function') {
      new ResizeObserver(function () { measure(bar); }).observe(bar);
    }
    window.addEventListener('resize', function () { measure(bar); });

    var formId = bar.getAttribute('data-form-id');
    var cta = bar.querySelector('.ibscent-promo-bar__cta');
    var close = bar.querySelector('.ibscent-promo-bar__close');

    cta.addEventListener('click', function (e) {
      e.preventDefault();
      openForm(formId);
    });

    close.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      try { localStorage.setItem(KEY, '1'); } catch (err) {}
      remove(bar);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function cleanupKlaviyoLeftovers() {
    document.body.classList.remove('klaviyo-prevent-body-scrolling');
    document.documentElement.classList.remove('klaviyo-prevent-body-scrolling');
    var nodes = document.querySelectorAll('[class*="kl-private-reset-css"]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var s = getComputedStyle(el);
      if (s.position !== 'fixed') continue;
      if (parseInt(s.zIndex, 10) < 1000) continue;
      var rect = el.getBoundingClientRect();
      if (rect.width < 500 || rect.height < 500) continue;
      el.style.pointerEvents = 'none';
      el.style.visibility = 'hidden';
      el.style.display = 'none';
    }
  }

  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.klaviyo-close-form')) {
      setTimeout(cleanupKlaviyoLeftovers, 150);
      setTimeout(cleanupKlaviyoLeftovers, 500);
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      setTimeout(cleanupKlaviyoLeftovers, 150);
    }
  });

  window.addEventListener('klaviyoForms', function (e) {
    if (!e.detail) return;
    var t = e.detail.type;
    if (t === 'close' || t === 'submit' || t === 'redirectedToUrl') {
      setTimeout(cleanupKlaviyoLeftovers, 150);
      setTimeout(cleanupKlaviyoLeftovers, 500);
    }
  });
})();
